import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import AuthStatusCard from "components/common/AuthStatusCard";

export default function AuthConfigurationError() {
  return (
    <AuthStatusCard
      icon={<WarningAmberRoundedIcon />}
      title="OIDC configuration required"
      message="The app cannot start SSO until the required environment variables are available."
      warning="Missing required OIDC environment variables. Check `.env.local` before starting the app locally."
      actions={[
        {
          label: "Reload page",
          onClick: () => window.location.reload(),
          variant: "secondary",
        },
      ]}
    />
  );
}
